import React from 'react';
import { Search } from 'lucide-react';
import { Card } from '../../atoms/Card';
import { Input } from '../../atoms/Input';
import { Button } from '../../atoms/Button';

export interface ContentSearchBarProps {
  searchQuery: string;
  filterHasReports: boolean;
  onSearchQueryChange: (query: string) => void;
  onFilterToggle: () => void;
  onSearch: (e: React.FormEvent) => void;
}

export const ContentSearchBar = ({
  searchQuery,
  filterHasReports,
  onSearchQueryChange,
  onFilterToggle,
  onSearch,
}: ContentSearchBarProps) => {
  return (
    <Card className="mb-6">
      <form onSubmit={onSearch} className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
        <div className="flex-1 relative min-w-0">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
          <Input
            type="text"
            placeholder="Başlık, içerik, ID veya slug ile ara..."
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            className="pl-10 w-full"
          />
        </div>
        <label className="flex items-center gap-2 cursor-pointer whitespace-nowrap flex-shrink-0">
          <input
            type="checkbox"
            checked={filterHasReports}
            onChange={onFilterToggle}
            className="w-4 h-4 text-accent border-gray-300 rounded focus:ring-accent focus:ring-2"
          />
          <span className="text-sm text-gray-700 font-medium">
            Sadece raporu olanlar
          </span>
        </label>
        <Button type="submit" variant="primary" className="flex-shrink-0 w-full sm:w-auto">
          Ara
        </Button>
      </form>
    </Card>
  );
};
